import { IPropertyPresentable, IPropertyEditable } from "../../../../base/domain/system/edit";
import { IQuoteBehavior, IImageContent } from "../../../../documaker/domain/format/objects";
import { IFormatSpecification } from "../IFormatSpecification";
import { IImageDrawableObject, } from "../objects";
import { IQuoteBehaviorPropertyEditable } from "../properties";
import { AbstractRectangleCoordinatableObjectEditor } from "./AbstractRectangleCoordinatableObjectEditor";

export abstract class AbstractImageDrawableObjectEditor<TObject extends IImageDrawableObject> extends AbstractRectangleCoordinatableObjectEditor<TObject> implements IQuoteBehaviorPropertyEditable {
  constructor(source: TObject | AbstractImageDrawableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._quoteBehavior = this.createPropertyEditor(s => s.quoteBehavior, (s, v) => s.quoteBehavior = v);
    this._formatId = this.createPropertyPresenter(s => s.formatId);
    this._imageContent = this.createPropertyPresenter(s => s.imageContent);
    this._temporaryImageContent = this.createPropertyEditor(
      s => s.temporaryImageContent,
      (s, v) => {
        s.imageContent.isEnable = false;
        s.temporaryImageContent = v;
      });
  }

  protected _quoteBehavior: IPropertyEditable<IQuoteBehavior>;
  protected _formatId: IPropertyPresentable<number>;
  protected _imageContent: IPropertyPresentable<IImageContent>;
  protected _temporaryImageContent: IPropertyEditable<IImageContent>;

  quoteBehavior(): IPropertyEditable<IQuoteBehavior> {
    return this._quoteBehavior;
  }

  formatId(): IPropertyPresentable<number> {
    return this._formatId;
  }

  imageContent(): IPropertyPresentable<IImageContent> {
    return this._imageContent;
  }

  temporaryImageContent(): IPropertyEditable<IImageContent> {
    return this._temporaryImageContent;
  }
}
